import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cuentasx-cobrar',
  templateUrl: './cuentasx-cobrar.component.html',
  styleUrls: ['./cuentasx-cobrar.component.css']
})
export class CuentasxCobrarComponent implements OnInit {

  
  url:string;
  urlSafe: SafeResourceUrl;
  
    constructor(public sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.url=environment.apiReportes+"cuentas_por_cobrar.rptdesign&id_emisor="+localStorage.getItem('id');
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
   
    }

}
